export default __webpack_public_path__ + "static/media/1790.c96ac8b7.png";